export const ACTIVE = 'Active'
export const INACTIVE = 'Inactive'

export const THOUGHT_LEADERSHIP = 'Thought Leadership'
export const AUTHOR = 'Author'
export const TOPIC = 'Topic'
export const PRODUCT_INSIGHTS = 'Product Insights'

export const ADVISOR = 'advisor'
export const INVESTOR = 'investor'
export const INSTITUTIONAL = 'institutional'
export const WHOLESALER = 'wholesaler'

export const SERVICE_LABEL_ADVISOR = 'Advisor'
export const SERVICE_LABEL_INVESTOR = 'Non-Advisor'
export const SERVICE_LABEL_WHOLESALER = 'Employee'
export const SERVICE_LABEL_WHOLESALER_ACTOR = 'Employee'
export const SERVICE_LABEL_USER = 'Advisor'

export const UI_LABEL_ADVISOR = 'Financial Professional'
export const UI_LABEL_INVESTOR = 'Individual Investor'
export const UI_LABEL_INSTITUTIONAL = 'Institutional Investor'

export const INSIGHTS_ROW_SIZE = 3
export const AUTHORS_ROW_SIZE = 3

export const FACT_SHEET = 'Fact Sheet'
export const COMMENTARY = 'Commentary'
export const ATTRIBUTION = 'Attribution/Contribution Report'
export const PRODUCT_UPDATES = 'Product Updates'

export const MODAL_TYPE_INSIGHTS = 'insights'
export const MODAL_TYPE_FUND = 'fund'

export const COLLECTIVE_INVESTMENT_TRUSTS = 'Collective Investment Trusts'

export const CAPITAL_GAINS_ESTIMATES_AND_DISTRIBUTIONS =
  'Capital Gains Estimates and Distributions'
